import { render, staticRenderFns } from "./ExamAddEdit.vue?vue&type=template&id=20fa9aa1"
import script from "./ExamAddEdit.vue?vue&type=script&lang=js"
export * from "./ExamAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports